import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asStateFlow

actual object RemoveAdsPurchases {
    private val mutableUiState = MutableStateFlow(
        RemoveAdsPurchaseUiState(isPurchasesSupported = false, entitlementsResolved = true)
    )

    actual val uiState: StateFlow<RemoveAdsPurchaseUiState> = mutableUiState.asStateFlow()

    actual fun configure(adsRemovedHint: Boolean, onAdsRemovedChanged: (Boolean) -> Unit) {
        mutableUiState.value = mutableUiState.value.copy(adsRemoved = adsRemovedHint)
    }
    actual fun purchaseRemoveAds() = Unit
    actual fun purchaseBankoPlus() = Unit
    actual fun purchaseBankoPlusAnnual() = Unit
    actual fun restorePurchases() = Unit
    actual fun refreshEntitlements() = Unit
    actual fun clearMessage() = Unit
}
